import React, { useState, useEffect } from 'react';
import { Typography, Button, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import './Hero.css';
import logo_img from '../img/logo512.png';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const Hero = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { t } = useTranslation();
  
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const logoSize = windowWidth < 768 ? Math.min(windowWidth * 0.7, 300) : Math.min(windowWidth * 0.4, 420);
  const titleSize = windowWidth < 768 ? '2rem' : windowWidth < 1024 ? '2.8rem' : '3.5rem';
  const paragraphSize = windowWidth < 768 ? '1.2rem' : '1.5rem';
  
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight * 1,
      behavior: 'smooth'
    });
  };

  return (
    <div className="hero-container" style={{ 
      marginTop: '-100px',
      padding: windowWidth < 768 ? '32px 24px' : '64px 48px', 
      textAlign: 'center', 
      color: 'white',
      position: 'relative',
      height: '100vh',
      minHeight: '500px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '68px',
      overflow: 'hidden'
    }}>
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6)), url("https://upload.wikimedia.org/wikipedia/commons/1/16/Bormio_da_Villa_Feleit_-_panoramio.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: windowWidth < 768 ? 'scroll' : 'fixed',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(4px)',
          WebkitFilter: 'blur(4px)',
          transform: 'scale(1.05)',
          zIndex: 0
        }}
      />
      <div style={{
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        maxWidth: '100vw',
      }}>
        <img 
          src={logo_img} 
          alt="Ca' De Campo Logo" 
          style={{ 
            height: `${logoSize}px`,
            width: 'auto',
            maxWidth: '90%',
            marginBottom: '0px',
            filter: 'drop-shadow(0px 0px 200px rgba(0, 0, 0, 0.9))',
            objectFit: 'contain'
          }} 
        />
        <Title style={{ 
          color: 'white', 
          marginTop: windowWidth < 768 ? '20px' : '44px', 
          marginBottom: windowWidth < 768 ? '16px' : '24px', 
          fontSize: titleSize,
          textShadow: '4px 4px 20px rgba(0, 0, 0, 0.9)'
        }}>
          {t('heroSection.title')}
        </Title>
        <Paragraph style={{ 
          fontSize: paragraphSize,
          color: 'rgba(255,255,255,0.9)',
          maxWidth: '90%',
          margin: '0 auto',
          marginBottom: windowWidth < 768 ? '40px' : '60px', // Increased space above button
          textShadow: '3px 3px 8px rgba(0, 0, 0, 0.8)'
        }}>
          {t('heroSection.tagline')}
        </Paragraph>
        <Space size="large" style={{ 
          filter: 'drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.7))'
        }}>
          <Button type="primary" size={windowWidth < 768 ? 'middle' : 'large'} href="https://www.airbnb.com/h/cadecampo">
            {t('heroSection.bookButton')}
          </Button>
        </Space>
      </div>
      
      <div 
        className="scroll-arrow" 
        onClick={scrollToContent} 
        style={{
          position: 'absolute',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1,
          cursor: 'pointer'
        }}
      >
        <DownOutlined style={{ 
          fontSize: windowWidth < 768 ? '18px' : '24px', 
          color: 'white',
          textShadow: '0px 4px 8px rgba(0, 0, 0, 0.8)' 
        }} />
      </div>
    </div>
  );
};

export default Hero;
